/*
 * @Author: princemwang
 * @Date: 2022-06-22 15:05:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-31 17:31:13
 */
import logoImg from '@/assets/imgs/tencent_logo.jpeg';
import { createInitFormText } from '@/globalState';
import './style.css';

const GroupHeader = () => {
  const [formText] = createInitFormText();
  return (
    <div id="header-content">
      <div className="webcast-header">
        <div className="webcast-log">
          <img src={logoImg} className="logo-img" />
        </div>
        <div className="web-nav">
          <a href="https://www.tencent.com/en-us/investors.html" className="web-home-btn" rel="noreferrer">
            Home
          </a>
        </div>
      </div>
      <div className="webcast-info">
        <div className="info-left">
          <span>{formText.title}</span>
        </div>
      </div>
    </div>
  );
};
export default GroupHeader;
